
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";
import { DefaultTextArea } from "@/models/api/orders/defaults";
import { IOrderResource } from "@/store/types";

const orderModule = getModule(OrderModule);

@Component
export default class OrderTextCards extends Vue {
  textAreas: Array<DefaultTextArea> = [];

  @Prop({ default: null })
  permissions: any;

  get currentOrder(): IOrderResource {
    return orderModule.currentOrder;
  }

  set currentOrder(val) {
    this.currentOrder = val;
  }

  mounted() {
    this.textAreas = [
      {
        title: "Intermediate Consignee",
        updateName: "IntermediateConsignee",
        value: this.currentOrder.intermediateConsignee,
        permission: this.permissions.order.edit.intermediateConsignee
      },
      {
        title: "Order Remarks",
        updateName: "Remarks",
        value: this.currentOrder.remarks,
        permission: this.permissions.order.edit.remark
      },
      {
        title: "Special Requests",
        updateName: "SpecialRequests",
        value: this.currentOrder.specialRequests,
        permission: this.permissions.order.edit.specialRequest
      },
      {
        title: "Driver Notes",
        updateName: "DriverNote",
        value: this.currentOrder.driverNote,
        permission: true
      }
    ];
  }

  updateOrder(prop, e) {
    const method = "update" + prop;
    orderModule[method](e.target.value);
  }

  get columns() {
    const total = this.textAreas.length;
    if (total > 1 && total < 13) {
      return 12 / this.textAreas.length;
    } else {
      return "12";
    }
  }
}
